// extracted by mini-css-extract-plugin
module.exports = {"p24":"SavePopover_p24__1vQB4","formControlLabel":"SavePopover_formControlLabel__2Ssby"};